"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var FormatText_1 = __importDefault(require("../FormatText"));
var Icon_1 = __importDefault(require("../Icon"));
var Panel = antd_1.Collapse.Panel;
var FilterWidget = function (_a) {
    var actions = _a.actions, title = _a.title, autoCloseFilter = _a.autoCloseFilter, children = _a.children, onActiveKey = _a.onActiveKey;
    var _b = react_1.useState('filterPanel'), activeKey = _b[0], setActiveKey = _b[1];
    var SearchButton = (react_1.default.createElement(__1.FormSubmitButton, { icon: "commons-search", onClick: function (_, formProps) {
            autoCloseFilter && setActiveKey([]);
            formProps.submitForm();
        } },
        react_1.default.createElement(FormatText_1.default, { id: "ui.commons.search", uppercase: true })));
    var filterActions = actions ? react_1.default.Children.toArray(actions) : SearchButton;
    react_1.useEffect(function () {
        if (onActiveKey) {
            if (activeKey.length >= 1) {
                onActiveKey(true);
            }
            else {
                onActiveKey(false);
            }
        }
    }, [activeKey]);
    return (react_1.default.createElement(__1.Widget, { className: "ant-app-actions-widget" },
        react_1.default.createElement(antd_1.Collapse, { bordered: false, defaultActiveKey: ['filterPanel'], activeKey: activeKey, onChange: function (value) { return setActiveKey(value); }, expandIcon: function () { return react_1.default.createElement(Icon_1.default, { name: "arrows-right_4" }); } },
            react_1.default.createElement(Panel, { key: "filterPanel", header: title || react_1.default.createElement(FormatText_1.default, { id: "ui.commons.filter", camelcase: true }), style: { border: 0 } },
                react_1.default.createElement(__1.Row, null, children),
                react_1.default.createElement("div", { className: "ant-app-widget-actions" }, filterActions)))));
};
exports.default = FilterWidget;
